import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputComponent } from './input/input.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SwitchComponent } from './switch/switch.component';
import { NgxMaskModule } from 'ngx-mask';
import { ListLogsComponent } from './list-logs/list-logs.component';
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";
import { MatIconModule } from '@angular/material/icon';
import { FlexLayoutModule } from '@angular/flex-layout';

import { OaSwitchComponent } from './ds/oa-switch.component';
import { OaNumberStepperComponent } from './ds/oa-number-stepper.component';
import { OaNoticeComponent } from './ds/oa-notice.component';
import { OaRadioCardComponent } from './ds/oa-radio-card.component';
import { OaInstallmentPickerComponent } from './ds/oa-installment-picker.component';
import { OaPaymentMethodCardComponent } from './ds/oa-payment-method-card.component';
import { OaValuesSummaryComponent } from './ds/oa-values-summary.component';
import { OaNotificationItemComponent } from './ds/oa-notification-item.component';

// Componentes do DS Orca App (ORCA-1929)
const DS_COMPONENTS = [
  OaSwitchComponent,
  OaNumberStepperComponent,
  OaNoticeComponent,
  OaRadioCardComponent,
  OaInstallmentPickerComponent,
  OaPaymentMethodCardComponent,
  OaValuesSummaryComponent,
  OaNotificationItemComponent,
];

@NgModule({
  declarations: [
    InputComponent,
    SwitchComponent,
    ListLogsComponent,
    ...DS_COMPONENTS
  ],
  imports: [
    CommonModule,
    
    ReactiveFormsModule,
    FlexLayoutModule,

    NgxMaskModule.forRoot(),
    NgxSkeletonLoaderModule,
    MatIconModule
  ],
  exports: [
    InputComponent,
    SwitchComponent,
    ListLogsComponent,
    ...DS_COMPONENTS
  ]
})
export class OrcaComponentsModule { }
